module.exports = __webpack_public_path__ + "img/Gr3.147bd35a.png";